<template>
    <div>
        <draggable class="d-flex flex-wrap form-group row" v-model="researchers"
                   :options="{draggable:'.researcher-item', filter: '.edit-card,.btn'}" @end="saveOrder">

            <researcher
                    v-model="researchers[key]"
                    :key="researcher.id"
                    v-for="(researcher, key) in researchers"
                    style="margin-bottom: 10px"
                    class="researcher-item"
                    ref="researchers"
                    :id="'researcher-'+researcher.id"
                    @delete="remove(key)"
                    @edit="closeOthers(key)"/>
            <div class="d-flex col-md-4" slot="footer" style="margin-bottom: 10px">
                <div class="card">
                    <div class="card-body d-flex flex-column">
                        <a href="#" class="btn btn-success" style="margin-top: auto;" @click.prevent="showCreateModal = true">Hinzufügen</a>
                    </div>
                </div>
            </div>
        </draggable>
        <b-modal ref="modal" v-model="showCreateModal" @ok="add">
            <h1 slot="modal-title">Person hinzufügen</h1>
            <div class="form-group">
                <label for="name">Name</label>
                <input type="text" id="name" v-model="researcherName" class="form-control">
            </div>
        </b-modal>
    </div>
</template>
<script>
import Researcher from "./Researcher";
export default {
  components: {
    Researcher
  },
  props: ["value"],
  data() {
    return {
      showCreateModal: false,
      researchers: this.value,
      researcherName: ""
    };
  },
  methods: {
    add() {
      let form = new FormData();
      form.append("create_researcher[name]", this.researcherName);
      axios
        .post("/api/" + store.state.language + "/researcher/create", form)
        .then(({ data }) => {
          this.researchers.push(data.result);
          this.researcherName = "";
          this.$emit("input", this.researchers);
        });
    },
    remove(key) {
      /**
       * TODO: delete from db
       */
      this.researchers.splice(key, 1);
      this.$emit("input", this.researchers);
    },
    closeOthers(key) {
      for (let i = 0; i < this.researchers.length; i++) {
        if (i != key) {
          this.$refs.researchers[i].stopEdit();
        }
      }
      this.$nextTick(() => {
        this.$scrollTo("#researcher-" + this.researchers[key].id, 500);
      });
    },
    saveOrder() {
      let ids = [];
      for (let i = 0; i < this.researchers.length; i++) {
        ids.push(this.researchers[i].id);
      }
      store.commit("addSavingProcess");
      axios
        .post(
          "/api/" + store.state.language + "/researcher/set_researcher_order",
          { blocks: ids }
        )
        .finally(() => {
          store.commit("finishSavingProcess");
        });
    }
  }
};
</script>
<style>
.form-group .card {
  width: 100%;
}
.not-edit.researcher-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Researchers.vue